import { useState } from 'react';
import debounce from 'transmute/debounce';
import PropTypes from 'prop-types';
import UITextArea from 'UIComponents/input/UITextArea';
import SavableFormLabel from './SavableFormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const saveValue = debounce(1000, (value, prevValue, setPrevValue, callback) => {
  if (value !== prevValue) {
    setPrevValue(value);
    callback(value);
  }
});

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message

function SavableTextAreaField(props) {
  const [prevValue, setPrevValue] = useState(props.value);
  const handleChange = value => {
    saveValue(value, prevValue, setPrevValue, props.onTextTyped);
    if (value !== prevValue) {
      props.onStartedEditing();
    } else {
      props.onCancelledEditing();
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavableFormLabel, {
      "data-test-id": "savable-label",
      helpLangPath: props.helpLangPath
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
      ,
      htmlFor: props.labelLangPath,
      isRequired: props.isRequired,
      isSaving: props.isSaving,
      labelLangPath: props.labelLangPath
    }), /*#__PURE__*/_jsx(UITextArea, {
      id: props.labelLangPath,
      "data-test-id": "text-area",
      defaultValue: props.value
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
      ,
      onChange: ({
        target: {
          value
        }
      }) => handleChange(value)
    })]
  });
}
SavableTextAreaField.propTypes = {
  helpLangPath: PropTypes.string,
  isRequired: PropTypes.bool,
  isSaving: PropTypes.bool,
  labelLangPath: PropTypes.string.isRequired,
  onCancelledEditing: PropTypes.func,
  onStartedEditing: PropTypes.func,
  onTextTyped: PropTypes.func.isRequired,
  value: PropTypes.string
};
SavableTextAreaField.defaultProps = {
  helpLangPath: undefined,
  isRequired: false,
  isSaving: false,
  onCancelledEditing: () => {},
  onStartedEditing: () => {},
  value: undefined
};
export default SavableTextAreaField;